import script from "./RecommendView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendView.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendView.vue?vue&type=style&index=0&id=e0c62c20&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c62c20"]])

export default __exports__